
// serviceName :: Event -> String
export const serviceName = event => event.detail.name.replace(/^[^.]+\./, '');

/** @typedef {Exclude<AppEventKey, '3rd-party:open' | 'app:online' | 'app:offline' | 'app:send:analytics' | 'data:updated' | 'error:fatal' | 'language:selection' | 'screensaver:start' | 'user:activity'>} AnAppKey */

/**
 * 
 * @param {*} args 
 * @returns {Record<AnAppKey, (event: CustomEvent) => void>}
 */
export function getEventHandlers (args) {

  const {
    context,
    appEvent$,
    clientId$,
    heartbeat$,
    toEvent,
    idleClientId
  } = args;

  const { analytics = {} } = context.imdSettings;

  const extra = (additional) => Object.assign({
    clientId: clientId$(),
    path: `/${context.imdHash}`,
    geoid: analytics.geoid
  }, additional);

  return {
    'app:start': () => {
      appEvent$(toEvent('App', 'ready', 'app', extra()));
    },
    'app:close': () => {
      appEvent$(toEvent('App', 'close', 'app', extra()));
      heartbeat$(Date.now());
    },
    'error:console': (error) => {
      const { msg, stack = [] } = error.detail;
      const { at = 'unknown', file = '?', lineColNo = '?' } = stack[0] || {};
      appEvent$(toEvent('Error', msg, `${at} ${file}:${lineColNo}`, extra()));
    },
    'error:heartbeat': (error) => {
      const { action, label } = error.detail;
      appEvent$(toEvent('Error', action, label, extra()));
    },
    'exception': (event) => {
      const { err , fatal = false } = event.detail;
      appEvent$(toEvent('Exception', err.message, `${err.filename} ${err.lineno}:${err.colno}`, extra({
        exDescription: err.message,
        exFatal: fatal
      })));
    },
    'language:change': (event) => {
      appEvent$(toEvent('Language', 'localize', event.detail, extra()));
    },
    'search': (event) => {
      const { term /*, results */ } = event.detail;
      appEvent$(toEvent('Search', 'term', term, extra()));
    },
    'service:closest:show': (event) => {
      appEvent$(toEvent('Service', 'show closest', serviceName(event), extra()));
    },
    'service:highlight': (event) => {
      appEvent$(toEvent('Service', 'highlight', serviceName(event), extra()));
    },
    'service:route': (event) => {
      appEvent$(toEvent('Service', 'route', serviceName(event), extra()));
    },
    'session:start': () => {
      clientId$(`${context.imdHash}_${Date.now()}`);
      appEvent$(toEvent('App', 'start', 'session', extra()));
    },
    'session:end': () => {
      appEvent$(toEvent('App', 'end', 'session', extra()));
      clientId$(idleClientId);
    },
    'view:change': (event) => {
      appEvent$(toEvent('View', 'navigate', event.detail, extra()));
    },
    'ui:transform': (event) => {
      appEvent$(toEvent('UI', 'transform', event.detail, extra()));
    },
  };
}

// export default {
//   getEventHandlers,
//   serviceName
// };

